export const formatResumeAddress = ({street_address, city, state, zipcode}) => {
  const trim = value => (typeof value === 'string' ? value.trim() : '');
  const street = trim(street_address);
  const cityVal = trim(city);
  const stateVal = trim(state);
  const zip = trim(zipcode);

  const cityState = [cityVal, stateVal].filter(Boolean).join(', ');
  const cityStateZip = [cityState, zip].filter(Boolean).join(' ');

  const parts = [];
  if (street) parts.push(street);
  if (cityStateZip) parts.push(cityStateZip);

  return parts.join(', ');
};
